<kl-form-container mode="edit" [loading]="loading()" [loadingText]="loadingText()" (commitSave)="onFormCommit($event)">
  <div id="kl-parameters" class="kl-parameters">
    @if (companyList().length > 0) {
      <div class="kl-parameters__company">
        <kl-select
          [formGroup]="companyForm"
          controlName="company"
          label="company"
          [options]="companyList()"
          optionLabel="description"
          [bindWholeObject]="true"
          [translateOptionLabels]="false"
          [filter]="true"
          placeholder="unselected"
          appendTo="body"
          inputId="kl-parameters-company"
          col="12"
          md="6"
          lg="4"
          [marginBottom]="true" />
      </div>
    }

    <div class="kl-parameters__grid">
      <p-table
        [value]="rows()"
        editMode="cell"
        class="p-datatable-sm p-datatable-gridlines kl-parameters-table"
        [tableStyle]="{ 'min-width': '100%' }"
        [scrollable]="false">
        <ng-template #header>
          <tr>
            <th class="kl-parameters__th-desc">{{ descriptionHeaderKey() | translate }}</th>
            <th class="kl-parameters__th-value">{{ valueHeaderKey() | translate }}</th>
            @if (value1Column()) {
              <th class="kl-parameters__th-value1">{{ value1HeaderKey() | translate }}</th>
            }
          </tr>
        </ng-template>

        <ng-template #body let-row let-ri="rowIndex">
          @if (isSectionRow(row)) {
            <tr class="kl-parameters__section-row">
              <td [attr.colspan]="columnCount()" class="kl-parameters__section-cell">
                <strong>{{ row.description | translate }}</strong>
              </td>
            </tr>
          } @else {
            <tr class="kl-parameters__data-row" (click)="selectedRowIndex.set(ri)">
              <td class="kl-parameters__desc-td" [class.kl-parameters__desc-td--selected]="selectedRowIndex() === ri">
                {{ row.description | translate }}
              </td>
              @if (valueReadonly()) {
                <td class="kl-parameters__value-td kl-parameters__value-td--readonly">
                  @switch (row.inputType) {
                    @case ('dropdown') {
                      @if (translateMapCaptions()) {
                        <span>{{ getDescription(row) | translate }}</span>
                      } @else {
                        <span>{{ getDescription(row) }}</span>
                      }
                    }
                    @case ('date') {
                      <span>{{ row.value | klDate }}</span>
                    }
                    @case ('password') {
                      <span>{{ row.value != null && row.value !== '' ? '••••••' : '' }}</span>
                    }
                    @case ('color') {
                      <span class="kl-parameters__color-cell">
                        {{ asString(row.value) }}
                        <span class="kl-parameters__color-swatch" [style.background-color]="asString(row.value)"></span>
                      </span>
                    }
                    @default {
                      <span>{{ asString(row.value) | translate }}</span>
                    }
                  }
                </td>
              } @else {
                <td class="kl-parameters__value-td" [pEditableColumn]="row.value" pEditableColumnField="value">
                  <p-cellEditor>
                    <ng-template #input>
                      @switch (row.inputType) {
                        @case ('number') {
                          <p-inputNumber
                            [ngModel]="row.value"
                            (ngModelChange)="patchRowNumber(ri, $event)"
                            [name]="'num-' + ri"
                            [min]="0"
                            [max]="999999999"
                            [maxFractionDigits]="row.maxFractionDigits ?? 2"
                            [minFractionDigits]="row.minFractionDigits ?? 0"
                            [showButtons]="false"
                            inputStyleClass="w-100"
                            class="w-100" />
                        }
                        @case ('date') {
                          <input
                            type="date"
                            class="form-control form-control-sm"
                            [ngModel]="toDateInputValue(row.value)"
                            (ngModelChange)="patchRowValue(ri, fromDateInputValue($event))" />
                        }
                        @case ('dropdown') {
                          <p-select
                            [options]="getDataMap(row.key_num ?? 0)"
                            optionLabel="description"
                            optionValue="value"
                            [ngModel]="row.value"
                            (ngModelChange)="patchRowValue(ri, $event)"
                            [filter]="true"
                            [placeholder]="'unselected' | translate"
                            appendTo="body"
                            class="kl-parameters__select">
                            @if (translateMapCaptions()) {
                              <ng-template let-item pTemplate="item">{{ item.description | translate }}</ng-template>
                              <ng-template let-item pTemplate="selectedItem">
                                @if (item) {
                                  {{ item.description | translate }}
                                }
                              </ng-template>
                            }
                          </p-select>
                        }
                        @case ('fileinput') {
                          <div class="kl-parameters__file">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              readonly
                              [value]="asString(row.value)" />
                            <input
                              type="file"
                              class="d-none"
                              [id]="'kl-param-file-' + ri"
                              [attr.accept]="row.accept ?? null"
                              (change)="onFileChosen(ri, $event)" />
                            <p-button
                              type="button"
                              icon="ph ph-upload-simple"
                              [text]="true"
                              (onClick)="fileInputClick(ri)"
                              [attr.aria-label]="'upload' | translate" />
                          </div>
                        }
                        @case ('selectable-input') {
                          <div class="input-group">
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              readonly
                              [attr.maxlength]="row.maxLength ?? null"
                              [value]="asString(row.value)" />
                            <button
                              type="button"
                              class="btn btn-outline-secondary"
                              (click)="openSelectableModal(ri)"
                              [attr.aria-label]="'select' | translate">
                              …
                            </button>
                          </div>
                        }
                        @case ('color') {
                          <input
                            type="color"
                            class="form-control form-control-sm form-control-color"
                            [ngModel]="asString(row.value) || '#FFFFFF'"
                            (ngModelChange)="patchRowValue(ri, $event)" />
                        }
                        @default {
                          <input
                            [type]="stringInputType(row)"
                            class="form-control form-control-sm"
                            [attr.maxlength]="row.maxLength ?? null"
                            [ngModel]="row.value"
                            (ngModelChange)="patchRowValue(ri, $event)" />
                        }
                      }
                    </ng-template>
                    <ng-template #output>
                      @switch (row.inputType) {
                        @case ('dropdown') {
                          @if (translateMapCaptions()) {
                            <span class="kl-parameters__cell-output">{{ getDescription(row) | translate }}</span>
                          } @else {
                            <span class="kl-parameters__cell-output">{{ getDescription(row) }}</span>
                          }
                        }
                        @case ('date') {
                          <span class="kl-parameters__cell-output">{{ row.value | klDate }}</span>
                        }
                        @case ('fileinput') {
                          <span class="kl-parameters__cell-output">{{ asString(row.value) }}</span>
                        }
                        @case ('selectable-input') {
                          <span class="kl-parameters__cell-output">{{ asString(row.value) }}</span>
                        }
                        @case ('password') {
                          <span class="kl-parameters__cell-output">
                            {{ row.value != null && row.value !== '' ? '••••••' : '' }}
                          </span>
                        }
                        @case ('number') {
                          <span class="kl-parameters__cell-output">{{ asString(row.value) }}</span>
                        }
                        @case ('color') {
                          <span class="kl-parameters__cell-output kl-parameters__color-cell">
                            {{ asString(row.value) }}
                            <span
                              class="kl-parameters__color-swatch"
                              [style.background-color]="asString(row.value)"></span>
                          </span>
                        }
                        @default {
                          <span
                            class="kl-parameters__cell-output kl-parameters__cell-output--string"
                            [title]="asString(row.value)">
                            {{ truncateMiddle(row.value) }}
                          </span>
                        }
                      }
                    </ng-template>
                  </p-cellEditor>
                </td>
              }
              @if (value1Column()) {
                <td class="kl-parameters__value-td kl-parameters__value-td--readonly">
                  {{ truncateMiddle(value1Text(row), 60) }}
                </td>
              }
            </tr>
          }
        </ng-template>

        <ng-template #emptymessage>
          <tr>
            <td [attr.colspan]="columnCount()" class="text-center text-muted">{{ 'no_data' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</kl-form-container>
